var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayCircleGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "limegreen",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.875 9.015l.028.02 1.516 1.01.027.018c.31.207.585.39.794.558.215.174.444.395.574.709.178.429.178.911 0 1.34-.13.314-.359.536-.574.71-.209.167-.483.35-.794.557l-.027.018-1.516 1.01-.028.02c-.38.253-.707.471-.981.62-.275.149-.614.296-.998.274a1.75 1.75 0 01-1.292-.692c-.232-.306-.297-.671-.326-.982-.028-.31-.028-.704-.028-1.16v-2.09c0-.456 0-.849.028-1.16.029-.31.094-.675.326-.982a1.75 1.75 0 011.292-.691c.384-.023.723.125.998.274.274.148.601.366.98.62zm-1.905.605a.25.25 0 00-.16.086c-.006.017-.024.08-.038.226-.021.234-.022.557-.022 1.058v2.02c0 .501 0 .824.022 1.058.014.147.032.209.038.226a.25.25 0 00.16.086c.018-.005.08-.024.21-.094.206-.112.475-.29.892-.568l1.515-1.01c.346-.231.562-.376.71-.496a.86.86 0 00.135-.125.25.25 0 000-.174.848.848 0 00-.134-.124c-.149-.12-.365-.266-.71-.496l-1.516-1.01a13.314 13.314 0 00-.893-.569c-.13-.07-.191-.089-.209-.094z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "none",
    stroke: "limegreen",
    strokeWidth: 1.5,
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleGame);
export default __webpack_public_path__ + "static/media/play-circle-game.35b9673a.svg";
export { ForwardRef as ReactComponent };